import { useQuery } from '@office-start/data-fetching';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { getAllCachedData } from '../operations/getAllCachedData';
export function useEdgeworthCachedAllItems() {
    var query = ['EdgeworthData', "CachedAll" /* QuerySubtype.CachedAll */];
    return useQuery(query, function () {
        return new Promise(function (resolve, reject) {
            scheduleWork(function () {
                getAllCachedData().then(resolve).catch(reject);
            }, IDLE_VERYLOW_PRIORITY);
        });
    }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });
}
//# sourceMappingURL=useEdgeworthCachedAllItems.js.map